import { Observable } from "rxjs";
import { AbstractService } from "../core/AbstractService";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { env } from "../../env/env";
import { StructureProgrammatiqueRequest } from "../data/http/requests/structureprogrammatique.req";
import { StructureProgrammatiqueResponse } from "../data/http/responses/structureprogrammatique.res";
import { AppService } from "../core/app.service";
import { ActivtieResponse } from "../data/http/responses/activite.response";
import { ActiviteRequest } from "../data/http/requests/activite.request";

@Injectable({ // Ajoutez le décorateur Injectable
    providedIn: 'root' // Rend le service disponible dans toute l'application
})
export class StructureProgammatiqueService extends AbstractService<StructureProgrammatiqueRequest, StructureProgrammatiqueResponse>{
    constructor(http: HttpClient, appService: AppService) {
        super(`${env.apiUrl}intervention`, http, null, appService);
    }
}
 